import type { IFramePostMessageData } from '../types';

export const isPostMessageData = (data: unknown): data is IFramePostMessageData =>
  typeof data === 'object' && data !== null && 'type' in data && 'value' in data;

export const isValidPostMessageEvent = (
  event: MessageEvent,
  origin: string
): event is MessageEvent<IFramePostMessageData> =>
  event.origin === origin && isPostMessageData(event.data);
